import { Directive, Input, TemplateRef } from '@angular/core';
import { StepState } from './stepper-state.service';

@Directive({
  selector: 'ng-template[awpStepperIcon]',
})
export class StepperIcon {
  /** Name of the icon to be overridden. */
  @Input('awpStepperIcon') name: StepState;

  constructor(public templateRef: TemplateRef<any>) {}
}